export {
  useGetPhoneNumber,
  type PhoneVerificationResult,
} from './api/get-phone-number'
export { useValidatePhoneNumber } from './api/validate-phone-number'

export { convertVerificationStatus } from './lib/converter'

export { type TPassportVerificationForm } from './model/passport-verification-form'
export { type TPhoneVerificationForm } from './model/phone-verification-form'

export {
  PassportVerificationButton,
  type Props as PassportVerificationButtonProps,
} from './ui/passport-verification'
export { CertificationButton } from './ui/certification-button'
export { PhoneVerificationButton } from './ui/phone-verification'
export {
  PassportDialog,
  PASSPORT_VERIFICATION_DIALOG,
} from './ui/passport-dialog'
